import {Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {Property} from "../../../model/property";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-parcel-map',
  templateUrl: './parcel-map.component.html',
  styleUrls: ['./parcel-map.component.css']
})
export class ParcelMapComponent implements OnDestroy {

  iframe_url: SafeResourceUrl

  private readonly messageHandler: (e: MessageEvent<Message>) => void;

  @Output() updateProperty = new EventEmitter<Property>();
  @Output() updateMapData = new EventEmitter();
  @Output() filterPropertyFoliosByParcels = new EventEmitter<{ validParcels: string[]; propertyTempId: string }>();
  @ViewChild('mapIframe', {static: false}) iframe!: ElementRef<HTMLIFrameElement>;

  constructor(private readonly sanitizer: DomSanitizer) {
    const url = `${environment.mapUrl}`;
    this.iframe_url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.messageHandler = this.handleMessage.bind(this);
    window.addEventListener('message', this.messageHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageHandler);
  }

  /**
   * Handles incoming message events and performs specific actions based on the message type and payload.
   *
   * @param {MessageEvent<Message>} e - The message event containing the data to be handled.
   * The event includes a `type` specifying the action to take and a `payload` with additional data.
   */
  private handleMessage(e: MessageEvent<Message>): void {
    const {type, payload} = e.data;

    switch (type) {
      case 'parcelChange':
        this.getPropertyFromMap();
        break;

      case 'propertyWithParcels':
        if (payload) {
          this.updateProperty.emit(payload);
        }
        break;

      case 'mapReady':
        this.updateMapData.emit();
        break;

      case 'validParcels':
        this.filterPropertyFoliosByParcels.emit(payload);
        break;
    }
  }

  /**
   * Sends a postMessage to the content window of the iframe requesting a property with type 'getProperty'.
   */
  private getPropertyFromMap(): void {
    this.iframe.nativeElement.contentWindow!.postMessage({type: 'getProperty'}, '*');
  }
}

interface Message {
  type: 'selectedParcels' | 'setCenter' | 'getSelectedParcels' | 'parcelChange' | 'markerMoved' | 'error' | 'propertyWithParcels' | 'mapReady' | 'validParcels';
  payload: any;
}
